import React, { useState, useEffect, useMemo } from 'react'
import CAMHeader from "../../../components/Header/CAMHeader";
import CAMDrawer from "../../../components/LeftSideBar/CAMDrawer";
import InvestigatorContainer from "../../../components/contsiners/InvestigatorContainer";
import TabsNav from "../common/ProcessNav";
import { Box } from "@mui/material";
import MultipleInput from "../../../components/Card/MultipleInput";
import Table from "./Table"
import Pagination from '../../../components/Pagination/index';
import Loader from '../../../components/Loader/loader';
import SnackBar from '../../../components/Snackbars/CustomizedSnackbars';
import AddSite from './AddSite';
import BatchFilterPopup from "../../investigationAnalysis/review/BatchFilterPopup";
import { useDispatch, useSelector } from "react-redux";
import * as site from "../../../redux/site/actions";
import ConfirmationDialog from '../../../components/DialogBox/Confirmation';
import debounce from "lodash.debounce";
import { formatLocal } from '../../../utility';
import { fetchProductsSitesAndUnitOfOperations } from "../../../redux/visualization/actions";
import { hasPermission } from "../../../utils/permissions";
import {
  CONFIGURATION_PERMISSIONS,
  PERMISSION_MODULES,
} from "../../../constants/permissions";

const SiteList = () => {
    const canAddSite = hasPermission(PERMISSION_MODULES.CONFIGURATION, CONFIGURATION_PERMISSIONS.ADD_MANUFACTURING_SITE);
    const canUpdateSite = hasPermission(PERMISSION_MODULES.CONFIGURATION, CONFIGURATION_PERMISSIONS.UPDATE_MANUFACTURING_SITE);
    const canApproveSite = hasPermission(PERMISSION_MODULES.CONFIGURATION, CONFIGURATION_PERMISSIONS.APPROVE_MANUFACTURING_SITE);

    const [page, setPage] = useState(1);
    const [filterOpen, setFilterOpen] = useState(false);
    const [openDailog, setOpenDailog] = useState(false);
    const [openConfirmDailog, setOpenConfirmDailog] = useState(false);
    const userName = localStorage.getItem('userName');
    const [formData, setFormData] = useState({
        site_name: '',
        user: userName
    });
    const [snack, setSnack] = useState({
        open: false,
        message: "",
        severity: "success",
    });
    const [openProduct, setOpenProduct] = useState(false);
    const [selectedRow, setSelectedRow] = useState();
    const rowsPerPage = 50;
    const [addErrors, setAddErrors] = useState();
    const dispatch = useDispatch();
    const rowData = useSelector((state) => state?.site);
    const [debouncedSearch, setDebouncedSearch] = useState();
    const [search, setSearch] = useState();
    const [filters, setFilters] = useState({
        from_date: "",
        to_date: "",
    });

    const handleReset = () => {
        setFilters({
            from_date: "",
            to_date: "",
        });
    }

    const handlePageChange = (event, value) => {
        setPage(value);
        getSiteListCall(value)
    };

    const handleChange = (field, value) => {
        setFilters((prev) => ({ ...prev, [field]: value }));
    };

    const debouncedSetValue = useMemo(
        () =>
            debounce((val) => {
                setDebouncedSearch(val);
            }, 700),
        []
    );

    const handleSearch = (e) => {
        setSearch(e.target.value);
        debouncedSetValue(e.target.value);
    };

    const validateAddErrors = (isRequired) => {
        setAddErrors({});
        const newErrors = {};
        if (!formData.site_name) {
            newErrors.site_name = "Required";
        } else {
            const regex = /[\/\\:*?"<>|\[\]]/;

            if (regex.test(formData.site_name)) {
                newErrors.site_name =
                    "Special characters are not allowed";
            }
        }
        setAddErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        let newValue;
        if (typeof value === "string") {
            newValue = value?.trim() === "" ? null : value;
        } else {
            newValue = value === "" ? null : value;
        }
        setFormData((prev) => ({ ...prev, [name]: newValue }));
    }

    const handleAddSubmit = async (e) => {
        e.preventDefault();
        if ((selectedRow && !canUpdateSite) || (!selectedRow && !canAddSite)) return;
        if (!validateAddErrors(false)) return;
        if (selectedRow) {
            try {
                const res = await dispatch(site.UpdateSite(formData));
                setSnack({
                    open: true,
                    message: res.data.message || "Updated successfully. Please review and approve.",
                    severity: "success"
                });
                setOpenProduct(false)
                getSiteListCall(page)
            } catch (error) {
                setSnack({
                    open: true,
                    message: error.response?.data?.error || "Something went wrong",
                    severity: "error"
                });
            }
        } else {
            try {
                const res = await dispatch(site.AddSite(formData));
                setSnack({
                    open: true,
                    message: res.data.message || "Added successfully. Please review and approve.",
                    severity: "success"
                });
                setOpenProduct(false)
                getSiteListCall(page)

            } catch (error) {
                setSnack({
                    open: true,
                    message: error.response?.data?.error || "Something went wrong",
                    severity: "error"
                });
            }
        }
    };

    const getSiteListCall = (page) => {
        const data = {
            page: page,
            page_size: rowsPerPage
        }
        if (search) data.search = debouncedSearch;
        if (filters.from_date) data.from_date = formatLocal(filters.from_date);
        if (filters.to_date) data.to_date = formatLocal(filters.to_date);
        dispatch(site.getSiteList(data))
    }

    useEffect(() => {
        setPage(1)
        getSiteListCall(1)
    }, [debouncedSearch])

    const handleDelete = async () => {
        try {
            const res = await dispatch(site.DeleteSite({ site_id: selectedRow.site_id, user: userName }));
            setSnack({
                open: true,
                message: res.data.message || "Deleted successfully",
                severity: "success"
            });
            setOpenDailog(false);
            getSiteListCall(page)

        } catch (error) {
            setSnack({
                open: true,
                message: error.response?.data?.message || "Something went wrong",
                severity: "error"
            });
        }

    }

    const handleUpdate = () => {

    }

    const handleGenerate = () => {
        getSiteListCall(1)
    }
    const handleAddSite = () => {
        if (!canAddSite) return;
        setAddErrors({});
        setOpenProduct(true)
        setFormData({
            site_name: '',
            user: userName
        })
        setSelectedRow('')
    }

    const handleMenuOption = (option, row) => {
        if (!canUpdateSite) return;
        setSelectedRow(row)
        if (option === 'Delete') {
            setOpenDailog(true);
        } else {
            setAddErrors({});
            setFormData({
                site_id: row.site_id,
                site_name: row.site_name,
                user: userName
            })
            setOpenProduct(true)
        }
    }

    const handleApprove = async () => {
        if (!canApproveSite || !selectedRow?.site_id) return;
        try {
            const res = await dispatch(site.ApproveSite({ site_id: selectedRow.site_id, user: userName }));
            setSnack({
                open: true,
                message: res.data.message || "Approved successfully",
                severity: "success"
            });
            setOpenConfirmDailog(false);
            getSiteListCall(page)
            dispatch(fetchProductsSitesAndUnitOfOperations(true));

        } catch (error) {
            setSnack({
                open: true,
                message: error.response?.data?.message || "Something went wrong",
                severity: "error"
            });
        }
    }

    const handleSiteApprove = (row) => {
        if (!canApproveSite) return;
        setSelectedRow(row)
        setOpenConfirmDailog(true)
    }

    return (
        <> <CAMHeader />
            <CAMDrawer />
            <InvestigatorContainer>  <TabsNav />

                <Box sx={{ borderTop: "1px solid #e0e0e0" }}>
                    <MultipleInput
                        text={'Site List'}
                        buttonText={"Add Site"}
                        popupFilter={true}
                        onButtonClick={handleAddSite}
                        isButton={canAddSite}
                        placeholder={"Search by site name"}
                        // isAuditLogs={true}
                        handleSearch={handleSearch}
                        search={search}
                        handlePopupFilter={() => setFilterOpen(true)}
                        // onBackClick={() => setViewLogs(false)}
                        isFillterIcon={false}
                    />
                </Box>
                {snack?.open && (
                    <SnackBar
                        className="popup"
                        handleClose={() => {
                            setSnack({
                                open: false,
                                message: "",
                                severity: "",
                            });
                        }}
                        severity={snack.severity}
                        state={snack?.open}
                        text={snack?.message}
                    />
                )}
                <Box>
                    <AddSite
                        open={openProduct}
                        formData={formData}
                        onChange={handleOnChange}
                        onClose={() => {
                            setAddErrors({});
                            setOpenProduct(false);
                        }}
                        errors={addErrors}
                        handleSubmit={handleAddSubmit}
                        dropdownOption={rowData}
                        site={rowData}
                    />
                </Box>
                <BatchFilterPopup
                    open={filterOpen}
                    onClose={() => setFilterOpen(false)}
                    filterValues={filters}
                    onReset={handleReset}
                    onGenerate={handleGenerate}
                    // data={auditLogs || []}
                    onChange={handleChange}
                    isStatusVisible={false}
                // filterOptions={filterOptions}
                />

                <Box width="100%" className="product-table">
                    {canApproveSite && <><ConfirmationDialog
                        open={openDailog}
                        title="Confirm Deletion"
                        message="Do you really want to delete this Unit Operation?"
                        onConfirm={handleDelete}
                        onCancel={() => setOpenDailog(false)}
                    />
                    <ConfirmationDialog
                        open={openConfirmDailog}
                        title="Confirm Approval"
                        message="Are you sure you want to approve this site?"
                        onConfirm={handleApprove}
                        onCancel={() => setOpenConfirmDailog(false)}
                        loading={rowData?.approving?.loading}
                        text='Approve'
                    /></>}
                    <Table data={rowData?.site || []} moreOption={canUpdateSite ? ["Update"] : []} handleMenuOption={handleMenuOption} handleApprove={canApproveSite ? handleSiteApprove : undefined} />
                    {rowData?.site?.loading && <Loader />}
                    <Pagination
                        count={rowData?.site?.data?.total / rowsPerPage}
                        page={page}
                        onChange={handlePageChange}
                    />
                </Box>
            </InvestigatorContainer>
        </>
    )
}

export default SiteList
